
// src/connects/stamp-palette.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import { inject } from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    onClose: (props)=> {
      props.ui && props.ui.callback && props.ui.callback(undefined)
      ownProps.updateUI({ active: false, requiredConfirm: false, code: undefined, callback: undefined })
    },

    onSelect: (code, props)=> {
      ownProps.updateUI({ active: props.ui.requiredConfirm, code: props.ui.requiredConfirm && code || undefined })
      props.ui.callback && !props.ui.requiredConfirm && props.ui.callback(code) || undefined
    },
    changeStampTab: ()=> {
      ownProps.updateUI({ code: undefined })
    },

    onSend: (props)=> {
      props.ui.callback && props.ui.code && props.ui.callback(props.ui.code)
      ownProps.updateUI({ active: false, requiredConfirm: false, code: undefined, callback: undefined })
    },

    showStampPalette: (callback, requiredConfirm)=> {
      ownProps.updateUI({ active: true, requiredConfirm, callback })
    },
  }
}

export default combineHOC(
  ui({ state: {
    active: false,
    requiredConfirm: false,
    code: undefined,
    callback: undefined,
    tabIndex: (props)=> props.params && props.params.tabIndex || 0
  }}),
  connect(undefined, mapDispatchToProps),
  translate(),
  lifecycle,
  inject({ showStampPalette: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/stamp-palette.js